
const estados = [
  {
    'id': 11,
    'nome': 'Rondônia',
    'uf': 'RO',
    'regiao': 1
  },
  {
    'id': 12,
    'nome': 'Acre',
    'uf': 'AC',
    'regiao': 1
  },
  {
    'id': 13,
    'nome': 'Amazonas',
    'uf': 'AM',
    'regiao': 1
  },
  {
    'id': 14,
    'nome': 'Roraima',
    'uf': 'RR',
    'regiao': 1
  },
  {
    'id': 15,
    'nome': 'Pará',
    'uf': 'PA',
    'regiao': 1
  },
  {
    'id': 16,
    'nome': 'Amapá',
    'uf': 'AP',
    'regiao': 1
  },
  {
    'id': 17,
    'nome': 'Tocantins',
    'uf': 'TO',
    'regiao': 1
  },
  {
    'id': 21,
    'nome': 'Maranhão',
    'uf': 'MA',
    'regiao': 2
  },
  {
    'id': 22,
    'nome': 'Piauí',
    'uf': 'PI',
    'regiao': 2
  },
  {
    'id': 23,
    'nome': 'Ceará',
    'uf': 'CE',
    'regiao': 2
  },
  {
    'id': 24,
    'nome': 'Rio Grande do Norte',
    'uf': 'RN',
    'regiao': 2
  },
  {
    'id': 25,
    'nome': 'Paraíba',
    'uf': 'PB',
    'regiao': 2
  },
  {
    'id': 26,
    'nome': 'Pernambuco',
    'uf': 'PE',
    'regiao': 2
  },
  {
    'id': 27,
    'nome': 'Alagoas',
    'uf': 'AL',
    'regiao': 2
  },
  {
    'id': 28,
    'nome': 'Sergipe',
    'uf': 'SE',
    'regiao': 2
  },
  {
    'id': 29,
    'nome': 'Bahia',
    'uf': 'BA',
    'regiao': 2
  },
  {
    'id': 31,
    'nome': 'Minas Gerais',
    'uf': 'MG',
    'regiao': 3
  },
  {
    'id': 32,
    'nome': 'Espírito Santo',
    'uf': 'ES',
    'regiao': 3
  },
  {
    'id': 33,
    'nome': 'Rio de Janeiro',
    'uf': 'RJ',
    'regiao': 3
  },
  {
    'id': 35,
    'nome': 'São Paulo',
    'uf': 'SP',
    'regiao': 3
  },
  {
    'id': 41,
    'nome': 'Paraná',
    'uf': 'PR',
    'regiao': 4
  },
  {
    'id': 42,
    'nome': 'Santa Catarina',
    'uf': 'SC',
    'regiao': 4
  },
  {
    'id': 43,
    'nome': 'Rio Grande do Sul',
    'uf': 'RS',
    'regiao': 4
  },
  {
    'id': 50,
    'nome': 'Mato Grosso do Sul',
    'uf': 'MS',
    'regiao': 5
  },
  {
    'id': 51,
    'nome': 'Mato Grosso',
    'uf': 'MT',
    'regiao': 5
  },
  {
    'id': 52,
    'nome': 'Goiás',
    'uf': 'GO',
    'regiao': 5
  },
  {
    'id': 53,
    'nome': 'Distrito Federal',
    'uf': 'DF',
    'regiao': 5
  }
]

export default estados



// WEBPACK FOOTER //
// ./src/vuex/cache/estados.js